import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CButton, CCard, CCardBody, CCol, CContainer, CRow } from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilCompass } from '@coreui/icons'

// Catch-all 404. Rendered inside AppLayout (see routes.tsx) so the sidebar and
// header stay in place and the user always has a way back.
const NotFound: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  return (
    <CContainer className="mt-5">
      <CRow className="justify-content-center">
        <CCol md={6}>
          <CCard className="text-center">
            <CCardBody className="p-5">
              <CIcon icon={cilCompass} size="3xl" className="text-body-secondary mb-4" />
              <div
                className="text-body-secondary text-uppercase fw-semibold mb-1"
                style={{ letterSpacing: '0.1em' }}
              >
                {t('notFound.eyebrow')}
              </div>
              <h2 className="mb-3">{t('notFound.title')}</h2>
              <p className="text-body-secondary mb-4">{t('notFound.message')}</p>
              <CButton color="primary" onClick={() => navigate('/')}>
                {t('notFound.goToDashboard')}
              </CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  )
}

export default NotFound
